export default [{
        path: 'index/:coursewareId/:quizId/:frequency',
        component(resolve) {
            require(['@/components/student/class-quiz/index'], resolve)
        },
        meta: {
            title: '问答'
        }
    },
    {
        path: 'card/:quizId',
        component(resolve) {
            require(['@/components/student/class-quiz/card'], resolve)
        },
        meta: {
            title: '答题卡'
        }
    },
    {
        path: 'result/:quizId/:number',
        component(resolve) {
            require(['@/components/student/class-quiz/result'], resolve)
        },
        meta: {
            title: '查看题目'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/student/quiz.js